// src/components/PublicRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export function PublicRoute({ children, role }) {
  const { isAuthenticated, user, loading } = useAuth();
  if (loading) return null;
  if (isAuthenticated)
    return (
      <Navigate
        to={role === "admin" ? "/admin/dashboard" : `/${user?.userId}`}
        replace
      />
    );
  return children;
}
